import { API_URL } from "@/config/constants";
import { buildUrl } from "@/utils";
import axios from "axios";
import { IFilter, Page } from "../api.types";
import {
    IAgent,
    IAgentCreate,
    IAgentFeatured,
    IAgentUpdate,
    IBindableTemplate,
} from "./agents.types";

const API = `${API_URL}/agents`;

export const getAgents = async (
    page: number = 1,
    size: number = 50,
    filter?: IFilter,
    search?: string | null
) => {
    const url = buildUrl(API, { page, size, search, ...filter });

    const result = await axios.get<Page<IAgent>>(url);
    return result.data;
};

export const getAllAgents = async () => {
    const firstPage = await getAgents(1, 100);
    if (firstPage.pages <= 1) {
        return firstPage.items;
    }

    const remainingPages = await Promise.all(
        Array.from({ length: firstPage.pages - 1 }, (_, index) =>
            getAgents(index + 2, 100)
        )
    );
    return firstPage.items.concat(remainingPages.flatMap((page) => page.items));
};

export const getAgent = async (id: number) => {
    const result = await axios.get<IAgent>(`${API}/${id}`);
    return result.data;
};

export const getAgentBySlug = async (slug: string) => {
    const result = await axios.get<IAgent>(`${API}/by-slug/${slug}`);
    return result.data;
};

export const getFeaturedAgents = async () => {
    const result = await axios.get<IAgentFeatured[]>(`${API}/featured`);
    return result.data;
};

export const createAgent = async (data: IAgentCreate) => {
    const result = await axios.post<IAgent>(API, data);
    return result.data;
};

export const updateAgent = async (id: number, data: IAgentUpdate) => {
    const result = await axios.put<IAgent>(`${API}/${id}`, data);
    return result.data;
};

export const deleteAgent = async (id: number) => {
    await axios.delete(`${API}/${id}`);
};

export const getBindableTemplates = async (
    id: number,
    organizationId: number | null
) => {
    const result = await axios.get<IBindableTemplate[]>(
        buildUrl(`${API}/${id}/bindable-templates`, {
            organization_id: organizationId,
        })
    );
    return result.data;
};
